import React, { Dispatch, SetStateAction } from 'react'
import SendGTAGEvent from '../../utils/sendGTAGEvent';

import FilterButton from '../FilterButton'
import FilterModal from '../FilterModal';

import { Container } from './styles'

interface IFilterState {
    env: string;
    search: string;
    priceRange: number[];
    size: string;
}

interface IFilterProps {
    filter: any;
    filterConfigs: {
        shouldHide: boolean;
        filterName: string;
        filterTitle: string;
        filterType: 'radio' | any;
        filterItems?: {
            filterItemName: string;
            filterItemValue: string | number[];
            id?: number;
        }[];
        isOpen: boolean;
    }[]
    onClearPage: () => void;
    onChangeFilterStatesHandler: (filterKey: string) => void;
    onClick: () => void;
    onCloseModal: () => void;
    isOpen: boolean;
    setFilter: Dispatch<SetStateAction<IFilterState>>;
    onClearFilter: () => void;
    activeFiltersCount?: number;
    className: string;
    shouldUseArrow?: boolean;
}

const Filter: React.FC<IFilterProps> = ({
    filter,
    className,
    filterConfigs,
    onClearPage,
    onChangeFilterStatesHandler,
    isOpen,
    onCloseModal,
    onClick,
    setFilter,
    onClearFilter,
    activeFiltersCount,
    shouldUseArrow,
    children
}) => (
    <Container className={className}>
        <FilterButton
            onClick={() => {
                onClick()
                SendGTAGEvent(
                    'botao_filtro',
                    'Filtro',
                    'Clicou em botão "Filtrar"')
            }
            }
            counter={activeFiltersCount}
            shouldUseArrow={shouldUseArrow}
            isOpen={isOpen}>
            {children}
        </FilterButton>

        <FilterModal
            isOpen={isOpen}
            onClose={onCloseModal}
            filterConfigs={filterConfigs}
            className={className}
            setFilter={setFilter}
            onClearPage={onClearPage}
            onClearFilter={onClearFilter}
            onChangeFilterStatesHandler={onChangeFilterStatesHandler}
            filter={filter}
        >
            {children}
        </FilterModal>
    </Container>
)

export default Filter